export default __webpack_public_path__ + "static/video-thumb-01-e7965f46872e25a1657b4972217d6777.jpg";